import { uniqBy } from 'lodash';

export function setEqual(a: Set<any>, b: Set<any>) {
  return a.size === b.size && [...a].every((value) => b.has(value));
}

export function uniqueBy<T>(items: T[], key: keyof T) {
  return uniqBy(items, key);
}

export function parseUserAcronym(displayName?: string | null) {
  const matches = displayName?.match(/\b(\w)/g);
  if (!matches || matches?.length < 2) {
    return 'JS';
  }
  return (matches[0] + matches[matches.length - 1]).toUpperCase();
}
